import React from 'react';
import './styles/Alert.css';

export const Alert = ({
  children,
  variant = 'info',
  icon: Icon,
  closeable = false,
  onClose,
  className = '',
  ...props
}) => {
  const [isOpen, setIsOpen] = React.useState(true);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  if (!isOpen) return null;

  const classes = `alert alert-${variant} ${className}`;

  return (
    <div className={classes} role="alert" {...props}>
      {Icon && <Icon className="alert-icon" />}
      <div className="alert-content">{children}</div>
      {closeable && (
        <button
          className="alert-close"
          onClick={handleClose}
          aria-label="Close alert"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export const AlertTitle = ({ children, className = '', ...props }) => (
  <h4 className={`alert-title ${className}`} {...props}>{children}</h4>
);

export const AlertDescription = ({ children, className = '', ...props }) => (
  <p className={`alert-description ${className}`} {...props}>{children}</p>
);

export default Alert;
